/* eslint-disable */
// @ts-nocheck

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import query from '@/api/APIServices'
import { VehicleParams } from '@/api/vehiclesAPI'

export const GET_ALL_VEHICLES_QUERY_KEY = 'vehicles'
export const GET_VEHICLE_QUERY_KEY = (vehicleId: number) => [
  'vehicle',
  vehicleId,
]

export function useServerLogisticVehicle() {
  const queryClient = useQueryClient()

  const getVehicles = () => {
    return useQuery({
      queryKey: [GET_ALL_VEHICLES_QUERY_KEY],
      queryFn: async () => {
        const response = await query.get('/cargo/vehicle')
        return response.data
      },
    })
  }
  const getVehicle = (vehicleId: number) => {
    return useQuery({
      queryKey: [GET_VEHICLE_QUERY_KEY, vehicleId],
      queryFn: async () => {
        const response = await query.get(`/cargo/vehicle/${vehicleId}`)
        return response.data
      },
      enabled: !!vehicleId,
    })
  }

  const createVehicle = (data: VehicleParams) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.post('/cargo/vehicle', data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_VEHICLES_QUERY_KEY],
        })
      },
    })
  }

  const updateVehicle = (vehicleId: number, data: Record<string, unknown>) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.put(`/cargo/vehicle/${vehicleId}`, data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            GET_VEHICLE_QUERY_KEY(vehicleId),
            GET_ALL_VEHICLES_QUERY_KEY,
          ],
        })
      },
    })
  }
  const deleteVehicle = (vehicleId: number) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.deleteAPI(`/cargo/vehicle/${vehicleId}`)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_VEHICLES_QUERY_KEY],
        })
      },
    })
  }
  return {
    getVehicles,
    getVehicle,
    createVehicle,
    updateVehicle,
    deleteVehicle,
  }
}
